export default {
  init() {
    // JavaScript to be fired on all pages
    $('#navbar-primary .navbar-nav li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 100) {
        $('.sticky-site-header').addClass('shadow_css');
      } else {
        $('.sticky-site-header').removeClass('shadow_css');
      }
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    window.addEventListener('load', function () {
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
        return;
      }

      var $ = jQuery;

      $('.js-testi-slider').not('.slick-initialized').slick({
        infinite: true,
        arrows: false,
        dots: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });

      function initSupportSlider() {
        var $slider = $('.js-support-slider');

        // Desktop
        if ($(window).width() >= 992) {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
          }
          return;
        }

        // Mobile/Tablet
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        $slider.slick({
          infinite: true,
          arrows: false,
          dots: $('.js-support-slider .support-slide').length > 3,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '200px',

          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode: false,
                centerPadding: '0',
                slidesToShow: 1,
                dots: true,
              },
            },
          ],
        });
      }

      var resizeTimer;

      initSupportSlider();

      $(window).on('resize', function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
          initSupportSlider();
        }, 200);
      });

      // ===== Scroll Animation =====
      const elements = document.querySelectorAll('.animate-on-scroll');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      }, {
        threshold: 0.15,
      });

      elements.forEach((el) => observer.observe(el));
      // ============================
    });
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js